{
  "remove": "删除"
}
